import component from './RouteLink';

export default component;
